import React from 'react';
import { useSelector } from 'react-redux';

import ActionButton from 'client/components/Result/Actions/ActionButton';

export default function SignUpFormButton({ btnStyle, onClick = () => {} }) {
    const { buttonText } = useSelector(s => s.signUpForm);

    return <ActionButton text={buttonText} btnStyle={btnStyle} onClick={onClick} />;
}
